<div class="w-12 flex flex-middle b-b b-col-1"
     [class.is-focus]="isFocus"
     (offClick)="isFocus=false"
     [offClickOff]="!isFocus"
     offClickFilter="search-outlet">
    <input class="input no-focus b-a-0 p-l-0"
           type="text"
           #input
           placeholder="Search"
           [(ngModel)]="term"
           (keyup)="keyup($event)"
           [style.font-size.rem]="1">

    <button class="m-t-2"
            type="button"
            (click)="goToSearch()">
        <i class="icon-search2 p-r-3"
           [style.font-size.px]="36"
           aria-hidden="true"></i>
    </button>
</div>
